// Selects the transport the map runs against, so a session can be driven from a
// recorded tape or a synthetic estate instead of the live hose.
//
//   ?perf=1                              instrumentation only, real server
//   ?record=1                            real server, capturing a tape
//   ?tape=/tapes/x.ndjson&rate=2&loop=1  replay a recorded tape
//   ?synth=1&apps=18&scopeRate=50        synthetic estate at a chosen scale
//
// Synth scale parameters: apps, envs, machines, procs, roles, cores, scopeRate,
// scopeMs, seed, vary, nesting.
//
// The defaults give a small, deliberately irregular estate — the one to look at
// placement and layout against. `&vary=0` makes every node take its full child
// count, which is the uniform stress estate the scale numbers were taken on:
//   ?synth=1&apps=18&envs=3&machines=3&procs=3&roles=4&vary=0&nesting=0

import { TapeSocket } from "./tape";
import { SynthSocket } from "./synth";
import { startRecording, record } from "./tape";
import { devtoolsParams } from "./params";

const SYNTH_NUMERIC_PARAMS = [
  "apps",
  "envs",
  "machines",
  "procs",
  "roles",
  "cores",
  "scopeRate",
  "scopeMs",
  "seed",
  "vary",
  "nesting",
];

const params = devtoolsParams;

export function recordTapeMessage(edata) {
  record(edata);
}

// True when the map is being driven by a fake transport, so callers can skip
// behaviour that only makes sense against the real server.
export function isSynthetic() {
  const p = params();
  return p.has("tape") || p.has("synth");
}

export function createWebSocket(realUrl) {
  const p = params();

  const tapeUrl = p.get("tape");
  if (tapeUrl) {
    return new TapeSocket(tapeUrl, {
      rate: parseFloat(p.get("rate")) || 1,
      loop: p.has("loop"),
    });
  }

  if (p.has("synth")) {
    const options = {};
    for (const name of SYNTH_NUMERIC_PARAMS) {
      const raw = p.get(name);
      if (raw != null && raw !== "") options[name] = parseFloat(raw);
    }
    return new SynthSocket(options);
  }

  if (p.get("record") === "1") startRecording();

  return new WebSocket(realUrl);
}
